const store = {
  title: '店铺授权',
  market: '市场',
  store_type: '店铺类型',
  all: '全部',
  market_vn: '越南',
  market_th: '泰国',
  market_id: '印尼',
  market_my: '马来西亚',
  market_ph: '菲律宾',
  market_sg: '新加坡',
  type_cross: '跨境店铺',
  type_local: '本土店铺',
  shop_local: '本土店',
  shop_cross: '跨境店',
  authorized: '已授权',
  store_code: '店铺编码',
  seller_email: '卖家邮箱',
  authorized_at: '授权时间',
  can_send: '可发 ',
  channel_dm: '私信',
  can_send_mid: '、 ',
  channel_email: '邮件',
  can_send_end: '， 并可发起',
  targeted_invite: '定向邀约',
  unbind: '解绑',
  unbind_title: '确认解绑店铺',
  unbind_confirm: '确认解绑',
  unbind_desc: '将释放 1 个槽位，撤销 token。该店私信任务暂停，进行中的定向邀约停止同步。',
  empty_slot: '空槽位',
  sea_only: '仅东南亚市场可授权',
  authorize_new: '授权新店',
  purchase_slot: '购买槽位',
  authorize_title: '授权 TikTok 店铺',
  go_authorize: '立即授权',
  authorize_desc: '将跳转 TikTok 官方授权页完成绑定，成功后占用 1 个空槽位。不存储店铺密码。',
  auth_market: '授权市场',
  auth_market_placeholder: '请选择东南亚市场',
  auth_market_hint: '当前仅支持东南亚市场店铺授权',
  authorize_redirect: '即将跳转 {{market}} 店铺授权',
  authorize_failed: '获取授权链接失败',
  unbind_success: '已解绑：{{name}}',
  unbind_failed: '解绑店铺失败',
  add_auth: '新增授权',
  safety_hint: '解绑释放槽位',
  load_failed: '店铺列表加载失败'
};

export default store;
